<template>
  <job-published-pasts
    title="過去のオプション情報プレビュー"
    component-name="job-published-option"
    :recent-past-objects="recentPastOptions"
    :past-objects="pastOptions"
  >
    <template #head>
      <tr data-test="head">
        <th class="boss-table-head-center">
          フォーマット
        </th>
        <th class="boss-table-head-center">
          記事名
        </th>
        <th class="boss-table-head-center">
          掲載期間
        </th>
        <th class="boss-table-head-center">
          プレビュー
        </th>
      </tr>
    </template>
  </job-published-pasts>
</template>

<script>
import JobPublishedPasts from '@/components/organisms/JobPublishedPasts'
export default {
  components: {
    JobPublishedPasts
  },
  props: {
    recentPastOptions: {
      type: Array,
      required: true
    },
    pastOptions: {
      type: Array,
      required: true
    }
  }
}
</script>
